import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'
import loadIntercom from '../../lib/loadIntercom'

function Intercom (...args) {
  if (!window.Intercom) {
    return console.debug('Intercom is not currently installed', ...args)
  }
  window.Intercom(...args)
}

export default {
  state: {
    visible: false,
    unread: 0,
    loaded: false
  },
  getters: {
    [getters.INTERCOM_VISIBLE] ({ visible }) {
      return visible
    },
    [getters.INTERCOM_UNREAD] ({ unread }) {
      return unread
    }
  },
  mutations: {
    [mutations.INTERCOM_LOADED] (state, loaded) {
      state.loaded = loaded
    }
  },
  actions: {
    async [actions.INTERCOM_BOOT] ({ state, rootGetters, commit }, user) {
      if (state.loaded) {
        return
      }

      commit(mutations.INTERCOM_LOADED, true)

      const { HELP_BUTTON } = rootGetters[getters.AUTH_GET_USER_CONFIG]
      const { type: mode, value: intercomAppID } = HELP_BUTTON

      if (mode !== 'intercom') {
        console.debug('Help button is not set to intercom mode')
        return
      }

      await loadIntercom(intercomAppID)

      // let method = state.loaded ? 'boot' : 'update'
      // boot once update user on route change
      Intercom('boot', {
        ...user,
        app_id: intercomAppID
      })

      // only init onUnreadCountOnce
      Intercom('onUnreadCountChangemethod', unreadCount => {
        state.unread = unreadCount
      })

      Intercom('onShow', _ => {
        state.visible = true
      })

      Intercom('onHide', _ => {
        state.visible = false
      })

      Intercom('hide')
    },
    async [actions.INTERCOM_TRACK] ({ state }, { event, context }) {
      Intercom('trackEvent', event, context)
    },
    async [actions.INTERCOM_SHOW] ({ state }) {
      Intercom('show')
    },
    async [actions.INTERCOM_HIDE] ({ state }) {
      Intercom('hide')
    },
    async [actions.INTERCOM_TOGGLE] ({ state, dispatch }) {
      return dispatch(state.visible ? actions.INTERCOM_HIDE : actions.INTERCOM_SHOW)
    }
  }
}
